export default [
  {
    id: 1,
    name: {
      en: "insecure",
      nl: "onzeker"
    },
    emoji: "🤔"
  },
  {
    id: 2,
    name: {
      en: "worried",
      nl: "bezorgd"
    },
    emoji: "😟"
  },
  {
    id: 3,
    name: {
      en: "afraid",
      nl: "bang"
    },
    emoji: "😨"
  },
  {
    id: 4,
    name: {
      en: "stressed",
      nl: "gestressed"
    },
    emoji: "😵"
  },
  {
    id: 5,
    name: {
      en: "anxious",
      nl: "angstig"
    },
    emoji: "😰"
  },
  {
    id: 6,
    name: {
      en: "lonely",
      nl: "eenzaam"
    },
    emoji: "😶"
  },
  {
    id: 7,
    name: {
      en: "isolated",
      nl: "geisoleerd"
    },
    emoji: "🤐"
  },
  {
    id: 8,
    name: {
      en: "depressed",
      nl: "depressief"
    },
    emoji: "😩"
  },
  {
    id: 9,
    name: {
      en: "sad",
      nl: "verdrietig"
    },
    emoji: "😢"
  },
  {
    id: 10,
    name: {
      en: "hurt",
      nl: "gekwetst"
    },
    emoji: "🤕"
  },
  {
    id: 11,
    name: {
      en: "disappointed",
      nl: "teleurgesteld"
    },
    emoji: "😞"
  },
  {
    id: 12,
    name: {
      en: "ashamed",
      nl: "schaamte"
    },
    emoji: "😖"
  },
  {
    id: 13,
    name: {
      en: "guilty",
      nl: "schuldig"
    },
    emoji: "😣"
  },
  {
    id: 14,
    name: {
      en: "disgusted",
      nl: "verafschuwd"
    },
    emoji: "🤢"
  },
  {
    id: 15,
    name: {
      en: "tired",
      nl: "moe"
    },
    emoji: "😴"
  },
  {
    id: 16,
    name: {
      en: "irritable",
      nl: "geirriteerd"
    },
    emoji: "😤"
  },
  {
    id: 17,
    name: {
      en: "bored",
      nl: "verveeld"
    },
    emoji: "😶"
  },
  {
    id: 18,
    name: {
      en: "angry",
      nl: "boos"
    },
    emoji: "😡"
  },
  {
    id: 19,
    name: {
      en: "happy",
      nl: "blij"
    },
    emoji: "😄"
  },
  {
    id: 20,
    name: {
      en: "hopeful",
      nl: "hoopvol"
    },
    emoji: "😇"
  },
  {
    id: 21,
    name: {
      en: "proud",
      nl: "trots"
    },
    emoji: "😅"
  },
  {
    id: 22,
    name: {
      en: "confident",
      nl: "zelfverzekerd"
    },
    emoji: "😉"
  },
  {
    id: 23,
    name: {
      en: "relieved",
      nl: "opgelucht"
    },
    emoji: "😌"
  },
  {
    id: 24,
    name: {
      en: "calm",
      nl: "kalm"
    },
    emoji: "😑"
  }
];
